import React from "react"
import MetaTags from "react-meta-tags"

import {
    Container
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import OnBoard from "components/Happy60/onboard";
import { getEmotionalQuotient, getSocialBehaviour } from "store/actions";
import { useDispatch } from "react-redux";


const OnBoarding = () => {
    const dispatch = useDispatch();
    dispatch(getEmotionalQuotient());
    dispatch(getSocialBehaviour());
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Onboarding | Happy60Plus</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumb title="Home" breadcrumbItem="Onboarding" />
                    <OnBoard />
                </Container>
            </div >
        </React.Fragment >
    );
}


export default OnBoarding;